// src/pages/admin/admin-login.component.jsx
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import './admin-login.styles.scss';

const AdminLogin = ({ history }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD = 'kohlacui';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (credentials.username === ADMIN_USERNAME && credentials.password === ADMIN_PASSWORD) {
      localStorage.setItem('adminLoggedIn', 'true');
      localStorage.setItem('adminUsername', credentials.username);
      localStorage.setItem('adminLoginTime', new Date().toISOString());
      setLoading(false);
      history.push('/admin');
    } else {
      setError('❌ Invalid username or password');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-box">
        <div className="login-logo">
          <span>🦁</span>
          <h2>Crispy Hair</h2>
          <p>Admin Panel</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>👤 Username</label>
            <input
              type="text"
              name="username"
              placeholder="Enter username"
              value={credentials.username}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>
          
          <div className="form-group">
            <label>🔒 Password</label>
            <input
              type="password"
              name="password"
              placeholder="Enter password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? 'Logging in...' : '🔐 Login'}
          </button>
        </form>
        
        <div className="login-hint">
          <p>Software Powered by : <strong>Atif Developers</strong>    <br />       Business Email: <strong>atifbilalriaz871@gmail.com</strong></p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(AdminLogin);